import { Check } from 'lucide-react';
import { type ReactNode } from 'react';

/** One choice in a sheet: the whole 56px row is the tap target, with a check when it's chosen. */
export const OptionRow = ({
  label,
  selected,
  role,
  trailing,
  onClick,
}: {
  label: string;
  selected: boolean;
  role: 'radio' | 'checkbox';
  trailing?: ReactNode;
  onClick: () => void;
}) => (
  <li>
    <button
      type="button"
      role={role}
      aria-checked={selected}
      onClick={onClick}
      className="active:bg-muted flex min-h-14 w-full items-center gap-3 px-4 py-3 text-left"
    >
      <span className={selected ? 'flex-1 text-sm font-semibold' : 'flex-1 text-sm'}>{label}</span>
      {trailing && <span className="text-muted-foreground text-sm tabular-nums">{trailing}</span>}
      <Check
        className={selected ? 'text-foreground h-4 w-4 shrink-0' : 'invisible h-4 w-4 shrink-0'}
        aria-hidden
      />
    </button>
  </li>
);

/** The list that holds `OptionRow`s: full-bleed in the sheet, a rule between rows. */
export const optionListClass = 'divide-border -mx-4 divide-y border-y';
